import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logRoute } from '../lib/build-info.js';

/**
 * #430 — logs the current in-app route (path + query + hash) to the console on
 * every navigation, so the deployed (Genesys-embedded) app makes the route it is
 * on visible for debugging. Renders nothing. Must live inside the Router.
 */
export function RouteLogger(): null {
  const location = useLocation();
  useEffect(() => {
    logRoute(`${location.pathname}${location.search}${location.hash}`);
  }, [location]);
  return null;
}
